@layer design-system {
  .stickyTableCell {
    position: sticky;
    left: 0;
    display: flex;
    gap: 12px;
    background-color: var(--background-default);
  }

  .stickyTableCellBorder {
    border-right: 1px solid var(--border-default);
  }
}
